module.exports = __webpack_public_path__ + "assets/sa-flag-md.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sa-flag-md.png
// module id = 87
// module chunks = 7